// Takes a font's name and transforms it into a Google Fonts URL. The `text`
// param loads specific letters to cut down on request size; `display=swap`
// allows a placeholder font to be shown before the real one is loaded.
export function formatUrl(font: string, weight: number) {
  const fontName = font.split(" ").join("+")
  const letters = font.replaceAll("+", "").replaceAll(" ", "")

  return `https://fonts.googleapis.com/css2?text=${letters}&family=${fontName}:wght@${weight}&display=swap`
}

// Injects a font <link> into the document head, with a uniqueness check to
// prevent the same font from being loaded multiple times. Fonts loaded this
// way persist when components unmount, which avoids flashes of unstyled
// text and unnecessary network requests when opening font menus.
export function injectFontImport(font: string, weight = 400) {
  const fontUrl = formatUrl(font, weight)
  const identifier = `font-${font}-${weight}`.replaceAll(" ", "-")

  if (document.querySelector(`link[data-font-id="${identifier}"]`)) {
    // This font was already loaded. Do nothing.
    return
  }

  const link = document.createElement("link")
  link.href = fontUrl
  link.rel = "stylesheet"
  link.setAttribute("data-font-id", identifier)
  document.head.appendChild(link)
}
